import { Style } from 'index';

const SearchContainerStyles: Style = {
    paginator: {
        display: 'flex',
        justifyContent: 'start',
        marginBottom: '1.25rem',
        marginTop: '0.5rem',
    },
};

export default SearchContainerStyles;
